import styled from "styled-components";
import * as h from "../../../../../ui/_themes/helpers";
import { BaseButton } from "../../../../../ui/BaseButton";

export const Button = styled(BaseButton)`
  width: 100%;
  height: 3em;
  line-height: 3em;
  border: ${({ primary }: any) =>
    primary
      ? h.getBorder("dialogPrimaryButton", "dialogs.buttons.primary")
      : h.getBorder("dialogSecondaryButton", "dialogs.buttons.secondary")};
  border-radius: 999px;
  background: ${({ primary }: any) =>
    primary
      ? h.getBackgroundColor("dialogPrimaryButton", "dialogs.buttons.primary")
      : h.getBackgroundColor(
          "dialogSecondaryButton",
          "dialogs.buttons.secondary"
        )};
  color: ${({ primary }: any) =>
    primary
      ? h.getColor("dialogPrimaryButton", "dialogs.buttons.primary")
      : h.getColor("dialogSecondaryButton", "dialogs.buttons.secondary")};
  font-size: 1.2em;
  vertical-align: middle;

  @media (max-width: 480px) {
    margin-bottom: 0.6em;

    &:only-child,
    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: 481px) {
    width: calc(50% - 0.8em);
  }
`;
